var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"text-xs-center":""}},[_c('userDebug'),_c('v-row',[_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('InfoCard'),_c('SavedFilters')],1),_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('QuickProductLinks')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }